import { KeyboardEvent, KeyboardEventHandler } from "react";

export const submitOnEnter =
  (userFunction: KeyboardEventHandler<HTMLInputElement>) =>
  (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      userFunction(e);
    }
  };
